<script lang="ts">
	import { browser } from '$app/env';
	import { isDarkMode } from '#lib/stores/dark-mode.js';
	import { themeStore } from '#lib/stores/theme.js';
	import { onMount } from 'svelte';

	const updateDarkModeStore = () => {
		isDarkMode.set(
			document.documentElement.classList.contains('dark') ||
				document.body.classList.contains('dark')
		);
	};

	// Detect system theme
	const toggleDarkMode = () => {
		if ($themeStore === 'system') {
			const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
			document.documentElement.classList.toggle('dark', isDark);
			document.body.classList.toggle('dark', isDark);
		}
	};

	onMount(() => {
		if (!browser) {
			return;
		}

		window
			.matchMedia('(prefers-color-scheme: dark)')
			.addEventListener('change', toggleDarkMode);

		toggleDarkMode();
		updateDarkModeStore();

		const bodyElement = document.body;

		// Make a mutation observer to watch for class changes on body element
		// and update the store accordingly
		const darkModeObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === 'class') {
					updateDarkModeStore();
				}
			});
		});

		// Observe changes to the class attribute of the body element
		darkModeObserver.observe(bodyElement, {
			attributes: true
		});

		return () => {
			darkModeObserver.disconnect();

			window
				.matchMedia('(prefers-color-scheme: dark)')
				.removeEventListener('change', toggleDarkMode);
		};
	});
</script>
